// Is the signed-in user a TaskPogo admin?
//
// The `taskPogoAdmins` Cognito group (amplify/auth/resource.ts) is what the
// TaskPogoPlaceWrite Lambda checks before letting anyone touch a curated place
// or mark one curated. The SPA reads the same group off the access token so it
// can stop OFFERING those writes -- hide the Delete button, lock the form --
// rather than let the user try and be refused. It is UX, not enforcement: the
// Lambda decides, and a hand-rolled request bypasses everything here.
//
// fetchAuthSession() itself rather than sessionWarm's cached promise: that
// promise is a signal that credentials are warm and its tokens go stale, and
// Amplify's own provider serves this from cache once warm anyway.

import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

export const ADMIN_GROUP = 'taskPogoAdmins';

// Pure: the groups claim as Amplify exposes it, or none.
export function groupsOfSession(session) {
  const groups = session?.tokens?.accessToken?.payload?.['cognito:groups'];
  return Array.isArray(groups) ? groups : [];
}

// Never throws: a page asking this while signed out, or while the session is
// broken, is asking "may I offer the admin controls", and the answer to that
// under any failure is no.
export async function currentUserIsAdmin() {
  try {
    return groupsOfSession(await fetchAuthSession()).includes(ADMIN_GROUP);
  } catch {
    return false;
  }
}

// `null` until answered, then a boolean. A page that must not offer an admin
// control before it knows treats null as "not yet" (Place.jsx does).
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(null);
  useEffect(() => {
    let mounted = true;
    currentUserIsAdmin().then((answer) => {
      if (mounted) setIsAdmin(answer);
    });
    return () => { mounted = false; };
  }, []);
  return isAdmin;
}
